module.exports = __webpack_public_path__ + "img/ring-circle.771f10d8.png";